import {h, Fragment} from "preact"
import { useAppStateSelector } from "@nosto/preact"

const h1El = document.querySelector('h1');

export default function Header() {
    const { pageType, total, loading, query } = useAppStateSelector(state => ({
        total: state.response.products?.total, 
        loading: state.loading,
        pageType: state.pageType,
        query: state.response?.query
    }))

    return (
        <div class="ns-serp-heading">
            <h1 class="ns-header ns-w-100 text-center">
                {((!total || total === 0) && !loading) ? (
                    'No Results Found'
                ) : pageType === 'category' ? (
                    h1El?.textContent || 'Ready to Wear'
                ) : (
                    `${total || 0} Search Results for "${query || ''}"`
                )}
            </h1>
        </div>
    )
}
